/** Match both legacy scalar and current array subject assignments from user/list. */
export const facultyHasSubject = (faculty, subjectId) => {
  const assigned = faculty?.["TblUsersSubjectRels.sub_id"];
  const subjectIds = Array.isArray(assigned) ? assigned : [assigned];
  if (subjectId === null || subjectId === undefined || subjectId === "") return false;
  return subjectIds.some((id) =>
    id !== null && id !== undefined && id !== "" &&
    Number.isFinite(Number(id)) && Number(id) === Number(subjectId)
  );
};
